export default "__VITE_ASSET__0966c952__"